import { HomePage } from "./../home/home";
import { PlazaCollectFeeConfirmPage } from "./../plaza-collect-fee-confirm/plaza-collect-fee-confirm";
import { ViewHeaderPage } from "./../view-header/view-header";
import { Storage } from "@ionic/storage";
import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams } from "ionic-angular";

@IonicPage()
@Component({
  selector: "page-plaza-collect-fee",
  templateUrl: "plaza-collect-fee.html",
})
export class PlazaCollectFeePage {
  plaza = "";
  space: any;
  bgImage = "";
  round = 1;
  theme = 1;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private storage: Storage
  ) {
    this.space = this.navParams.data.space;
    this.bgImage = "assets/bg/shop/" + this.space.shop.shop_id + ".jpg";
  }

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    this.storage.get("info").then((info) => {
      if (info.team.plaza_id == 1) {
        this.plaza = "A";
      } else if (info.team.plaza_id == 2) {
        this.plaza = "B";
      } else if (info.team.plaza_id == 3) {
        this.plaza = "C";
      } else if (info.team.plaza_id == 4) {
        this.plaza = "D";
      } else if (info.team.plaza_id == 5) {
        this.plaza = "E";
      } else if (info.team.plaza_id == 6) {
        this.plaza = "F";
      } else {
        this.plaza = info.team.plaza_id;
      }
    });

    this.storage.get("roundGame").then((round) => {
      this.round = round;
    });
  }

  confirm() {
    this.navCtrl.push(PlazaCollectFeeConfirmPage, { space: this.space });
  }

  backPage() {
    this.navCtrl.pop();
  }

  homePage() {
    this.navCtrl.setRoot(HomePage);
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/plaza-collect-fee/plaza-collect-fee.ts